import { useAuthContext } from '@repo/user-session';
import fetch from 'isomorphic-fetch';
import { FetchFunction } from 'relay-runtime';

const useFetchRelayFactory = (token: string, zentSessionId: string, zentClientSessionId: string) => {
  const { setStatusSignOut } = useAuthContext();

  const fetchRelay: FetchFunction = async (params, variables) => {
    if (process.env.NODE_ENV === 'development') {
      console.info('-QUERY_FETCH_LOG:', params.name, variables);
    }

    let headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };
    const apiServer = process.env.NEXT_PUBLIC_GQL_API_SERVER ?? '';
    if (token) {
      headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Zent-Session-Id': `${zentSessionId}`,
        'X-Zent-Client-Session-Id': `${zentClientSessionId}`
      };
    }

    try {
      const response = await fetch(apiServer, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          query: params.text as string,
          variables
        })
      });

      const result = await response.json();
      if (result.errors) {
        if (result.errors.some(({ code }: { code: string }) => code === 'FORBIDDEN')) {
          console.error('Access forbidden. Clearing access token and reloading the page.');
          setStatusSignOut();
          return;
        }
      }

      return result;
    } catch (error: any) {
      console.error('fetchGraphQL error:', error);
      return new Promise((resolve) => {
        resolve({ data: {} });
      });
    }
  };

  return fetchRelay;
};

export default useFetchRelayFactory;
